import React from 'react';
import './skeleton.css';

/**
 * 배너 영역 스켈레톤 UI 컴포넌트
 * 페이지 배너가 로딩 중일 때 표시
 */
const BannerSkeleton = () => {
  return (
    <div className="skeleton-banner-container">
      <div className="container">
        <div className="skeleton-line" style={{ width: '40%', height: '32px', marginBottom: '12px' }}></div>
        <div className="skeleton-line" style={{ width: '60%', height: '16px' }}></div>
      </div>
    </div>
  );
};

export default BannerSkeleton;

